export const userlist = {
    data:null,
    is_data_loading:false,
}


// WEBPACK FOOTER //
// ./src/reducers/userlist/userlist.state.js